import NotificationAudio                from 'assets/audios/notification.mp3';

class AudioService  {
  notification(){
    const audio = new Audio(NotificationAudio)
    audio.addEventListener('canplaythrough', (event) => {
      // the audio is now playable; play it if permissions allow
      audio.play();
    });
  }
}

export default new AudioService();